<template>
  <p class="footicp" :class="['icp_' + $route.name]" v-if="LIMI_ENV">
    Copyright © {{year}} 狸米新启航
    <a href="/static/agreement/agreement.html" target="_blank">用户协议</a>
    <a target="_blank" href="http://beian.miit.gov.cn/">
      京ICP备2024071287号-6
    </a>
  </p>
</template>
<script>
import common from 'common';
export default {
  data() {
    return {
	  LIMI_ENV: LIMI_ENV !== "electron",
	  year:new Date(common.getTemServerTime()*1000).getFullYear(),
	};
  }
};
</script>

<style rel="stylesheet/stylus" lang="less" scoped>
.footicp {
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.3;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  a {
    color: #fff;
  }
  img {
    border: none;
    vertical-align: middle;
    opacity: 0.88;
  }
}
.icp_course {
  position: absolute;
  bottom: -30px;
}
@media screen and (max-height: 668px) {
  .footicp {
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/icp.vue